var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blog_post",
    "data-name": "blog post",
    width: 40,
    height: 40,
    transform: "translate(710 1474)",
    fill: "rgba(0,0,0,0.13)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_95825",
    "data-name": "Mask Group 95825",
    transform: "translate(-710 -1474)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172087",
    "data-name": "Group 172087",
    transform: "translate(716.984 1480.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172086",
    "data-name": "Group 172086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172085",
    "data-name": "Group 172085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172083",
    "data-name": "Group 172083",
    transform: "translate(5.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172112",
    "data-name": "Path 172112",
    d: "M11,1.44a5.158,5.158,0,1,0,5.151,5.151A5.168,5.168,0,0,0,11,1.44Z",
    transform: "translate(-5.84 -1.44)",
    fill: "#E39DFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172084",
    "data-name": "Group 172084",
    transform: "translate(0 10.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172113",
    "data-name": "Path 172113",
    d: "M14.977,9.935l-.285-.065-.246.155a4.456,4.456,0,0,1-4.336,0L9.864,9.87l-.285.065A11.712,11.712,0,0,0,1.7,16.264l-.207.414.3.362a13.373,13.373,0,0,0,8.75,4.893,7.4,7.4,0,0,1-.233-1.916V18.024c0-3.495,1.941-5.54,5.76-6.083a28.636,28.636,0,0,1,3-.168A11.96,11.96,0,0,0,14.977,9.935Z",
    transform: "translate(-1.49 -9.87)",
    fill: "#E39DFF"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_172114",
    "data-name": "Path 172114",
    d: "M20.457,12.5c-.686-.1-2.343-.155-3.262-.168-.906.013-2.563.065-3.249.168-1.993.285-4.647,1.087-4.647,4.8v1.993c0,3.715,2.653,4.53,4.647,4.8.66.091,2.317.155,3.262.168.932-.013,2.589-.078,3.249-.168,1.993-.285,4.647-1.087,4.647-4.8V17.3C25.1,13.6,22.45,12.783,20.457,12.5Zm-.79,6.252-3.443,1.993a.52.52,0,0,1-.777-.453V16.317a.52.52,0,0,1,.777-.453l3.443,1.993A.511.511,0,0,1,19.668,18.75Z",
    transform: "translate(0.809 1.765)",
    fill: "#E39DFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubers);
export default __webpack_public_path__ + "static/media/youtubers.7d4be3e33ffe5f428328f5df5c8f5eda.svg";
export { ForwardRef as ReactComponent };